import React, { useState, useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import NavBar from "../elements/navBar";
import "./header.css";
import axios from "axios";
import { Link } from "react-router-dom";
function HeaderCarousel(props) {
  const [data, setData] = useState([]);
  useEffect(() => {
    const getFormations = async () => {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "activities/Formations"
      );
      setData(response.data.formations);
    };
    getFormations();
  }, []);

  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimenion]);

  return (
    <div>
      <NavBar type={props.type} />
      <div className="arrowImageSlidingEducation">
        <Carousel fade variant="danger">
          <Carousel.Item>
            <img
              src={
                windowDimenion.winWidth > 700
                  ? "images/learn3.jpg"
                  : "images/learnmob.jpg"
              }
              className="mainCarouselEducation"
              alt="Second slide"
            />

            <Carousel.Caption>
              <h3 className="h3carouselEducation">Learn</h3>
              <p className="paragrapheCarouselEducation">
                Via hands on workshops
              </p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              src={
                windowDimenion.winWidth > 700
                  ? "images/make2.jpg"
                  : "images/droneMobile.jpg"
              }
              alt="Third slide"
              className="mainCarouselEducation"
            />

            <Carousel.Caption>
              <h3 className="h3carouselEducation">Make</h3>
              <p className="paragrapheCarouselEducation">Your Ideas happen</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <div>
              <img
                src={
                  windowDimenion.winWidth > 700
                    ? "images/innovate2.jpg"
                    : "images/innovatemob.png"
                }
                className="mainCarouselEducation"
                alt="Fi/rst slide"
              />
              <div className="rightArrowSlidingEducation"></div>
            </div>
            <Carousel.Caption>
              <h3 className="h3carouselEducation">Innovate</h3>
              <p className="paragrapheCarouselEducation">
                By creating awesome things
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </div>
      <div className="prochainFormations">
        {data &&
          data.map(
            (e) =>
            (e.date && e.date!==" " ) && (
                <Link  to={`/education/formation/${e._id}`}
                  className="prochainFormation"
                  key={e._id}
                >
                  <img
                    className="imageProchaineFormation"
                    src={e.images && e.images.url}
                    alt=""
                  />
                  <div className="informationsProchaineFormation">
                    <div className="titreProchaineFormation">
                      {e.name && e.name}
                    </div>
                    <div className="descriptionProchaineFormation">
                      {(e.date && e.date!==" " )&& e.date}
                    </div>
                  </div>
                </Link>
              )
          )}
      </div>
    </div>
  );
}

export default HeaderCarousel;
